import React, { useState, useRef, useEffect, useContext } from "react";
import './style.css'
import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getStoredUser } from '../../utils/safeStorage';
import { SidebarContext } from "../../AppRoutes";
import { getCategorias, getItens, updateItensOrder, updateItemOut, updateItemPrice, deleteItem } from "../../services/api";

import PermissionGate from "../../services/PermissionGate";
import InputMoney from "./InputMoney";
import { useNavigate } from "react-router-dom";

import ConfirmDialog from "../../components/ConfirmDialog";

import { toast } from "react-toastify";
import Loading from "react-loading";
import { useTranslation } from 'react-i18next';




import * as FiIcons from 'react-icons/fi'
import * as AiIcons from 'react-icons/ai'
import * as SlIcons from 'react-icons/sl'

import { MdFastfood } from "react-icons/md";
import SafeImage from '../../components/SafeImage';
import { MdKeyboardArrowDown } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FaRegTrashAlt } from "react-icons/fa";
import { IoLink } from "react-icons/io5";
import { MdDragIndicator } from "react-icons/md";

import ModalEditCategoria from "../../components/ModalEditCategoria";
import { formatPriceWithSymbol } from '../../utils/currency';

import { Draggable, Droppable, DragDropContext } from '@hello-pangea/dnd';

const Teste = styled.div`
    display: flex;
    margin-left:  ${({ sidebar }) => (sidebar ? '250px' : '100px')}; 
    height:auto;
    width:auto;
    transition: 150ms;
    background-color:rgb(255,255,255)!important;
    overflow: initial;
    z-Index: 9;

    @media (max-width: 880px) {
        margin-left: 0;
    }
`;


const ListItem = ( {list = []}) =>{
    //const { user } = useContext(AuthContext);
    const { t } = useTranslation('categorias');

    //TESTES
    const userParse = getStoredUser();
    const userID = userParse?._id;
    const empresa = localStorage.getItem('empresa')
    const empresaParse = JSON.parse(empresa)
    const empresaObjId = empresaParse._id;
    const idEmpresa = empresaParse.id_empresa
    const vinculo_empresa = empresaParse.cnpj;
    const nomeEmpresa = empresaParse.name;
    const nomeEmpresaForUrl = nomeEmpresa.replace(/\s+/g, '-').replace(/[A-Z]/g, c => c.toLowerCase());

    const navigate = useNavigate();


    const [visibleDropdown, setVisibleDropdown] = useState(null);
    const [visibleInput, setVisibleInput] = useState(null);
    

    const [categorias, setCategorias] = useState([]);
    const [itens, setItens] = useState([]);
    const [selectedCategoria, setSelectedCategoria] = useState("");

    const [num] = useState(itens.map(item => 1));

    const [filter, setFilter] = useState('');
    const [result, setResult] = useState(false);

    const [order, setOrder] = useState(1)
    const [columnOrder, setColumnOrder] = useState("")
    const [currentPrice, setCurrentPrice] = useState(0);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const { sidebar } = useContext(SidebarContext);;
    
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);

    const [showEditCategoria, setEditCategoria] = useState(true);

    useEffect(() => {
        (async () => {
            const response = await getCategorias(userID, idEmpresa, vinculo_empresa, empresaObjId)
            const itemTemp = await getItens(userID, idEmpresa, vinculo_empresa, empresaObjId)

            ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("itemTemp.data.itens>",itemTemp.data.itens);

            setCategorias(response.data.categorias);
            setItens(itemTemp.data.itens);
            setLoading(false);
            setRefresh(false);    

        })();
    },[refresh]);



    const [confirmOpen, setConfirmOpen] = useState(false);
    const [shouldDelete, setShouldDelete] = useState(false);
    const [idToDelete, setIdToDelete] = useState('');
    const handleDeleteItem = (idRecebido) => {
        // Abre Componente de Confirmação do delete
        setConfirmOpen(true)

        setIdToDelete(idRecebido)
        if(idRecebido){
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ID RECEBIDO:",idRecebido)
            setShouldDelete(true);
        }
    }
    const deleteReg = async () => {
        if(shouldDelete){
            deleteItem(userID, idToDelete).then( cast => {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("RESULT DELETE:",cast);
                if(cast.status===201){
                    toast(cast.data.msg,{ autoClose: 5000 , type: "success"});
                    setRefresh(true);
                }else{
                    toast(cast.data.msg,{ autoClose: 5000 , type: "error"});
                }
            }).catch( err => {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ERROR:",err);
                toast(err.response.data.msg,{ autoClose: 5000 , type: "error"});
            });
        }

    }

    /*const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setVisibleDropdown(null);
        }
        if (inputRef.current && !inputRef.current.contains(event.target)) {
            setVisibleInput(null);
        }
    };*/
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setVisibleDropdown(null);
        }
        if (inputRef.current && !inputRef.current.contains(event.target)) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("visibleInput>>",visibleInput)
            if (visibleInput !== null) {
                const item = itens.find(it => it._id === visibleInput);
                handleBlurOrEnter(item._id, item.id_item, currentPrice);
                //setVisibleInput(null);
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [visibleInput, currentPrice, itens]);

    const toggleOptions = (id) => {
        if (visibleDropdown === id) {
            setVisibleDropdown(null);
        } else {
            setVisibleDropdown(id);
        }
    };

    const toggleInput = (id, price) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("toggleInput de ID> ", id)
        setCurrentPrice(price);
        setVisibleInput(id);
    };

    /*const handleDeleteClick = async (id) => {
        // Implementar a lógica para excluir o item
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Excluir item com id:', id);
        const response = await deleteItem(userID, id);
        if (response.status === 201) {
            toast('Item excluído com sucesso', { autoClose: 2500, type: 'success' });
            setRefresh(true);
        } else {
            toast('Erro ao excluir o item', { autoClose: 2500, type: 'error' });
        }
    };*/

    const handleEditAdditionalClick = (id) => {
        // Implementar a lógica para editar adicionais do item
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Editar adicionais do item com id:', id);
    };

    const handleCheckboxChange = async (itemID, id_item, currentOut) => {
        const newOutValue = !currentOut;
        setItens(prevItens =>
            prevItens.map(item =>
                item._id === itemID ? { ...item, out: newOutValue } : item
            )
        ); // Atualiza o estado local imediatamente

        try {
            const response = await updateItemOut(userID, itemID, id_item, idEmpresa, newOutValue);
            if (response.status === 200) {
                toast(t('item.updateSuccess'), { autoClose: 2500, type: 'success' });
                setRefresh(true);
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao atualizar item:', error);
            toast(t('item.updateError'), { autoClose: 2500, type: 'error' });
            // Reverte o estado local se a atualização falhar
            setItens(prevItens =>
                prevItens.map(item =>
                    item._id === itemID ? { ...item, out: currentOut } : item
                )
            );
        }
    };

    const handleBlurOrEnter = async (itemID, id_item, currentPrice) => {
        setVisibleInput(null); // Esconde o input
        try {
            const response = await updateItemPrice(userID, itemID, id_item, idEmpresa, parseFloat(currentPrice));
            if (response.status === 200) {
                toast(t('item.priceUpdateSuccess'), { autoClose: 2500, type: 'success' });
                setRefresh(true);
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao atualizar preço do item:', error);
            toast(t('item.priceUpdateError'), { autoClose: 2500, type: 'error' });
            // Reverte o estado local se a atualização falhar
            setItens(prevItens =>
                prevItens.map(item =>
                    item._id === itemID ? { ...item, price: parseFloat(currentPrice) } : item
                )
            );
        } finally {
            setVisibleInput(null); // Esconde o input
        }
    };
    /*const handleBlurOrEnter = async (itemID, id_item, price) => {
        try {
            const priceAsNumber = price;
            if (isNaN(priceAsNumber)) {
                throw new Error('Invalid price');
            }
            const response = await updateItemPrice(userID, itemID, id_item, idEmpresa, priceAsNumber);
            if (response.status === 200) {
                toast(t('item.priceUpdateSuccess'), { autoClose: 2500, type: 'success' });
                setRefresh(true);
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao atualizar preço do item:', error);
            toast(t('item.priceUpdateError'), { autoClose: 2500, type: 'error' });
            // Reverte o estado local se a atualização falhar
            setItens(prevItens =>
                prevItens.map(item =>
                    item._id === itemID ? { ...item, price: parseFloat(price) } : item
                )
            );
        } finally {
            setVisibleInput(null); // Esconde o input
        }
    };*/

    /*const onChange = (event, nameObject, isNumber) => {
        setValuePreco(isNumber ? Number(event.target.value) : event.target.value);
        formik.setFieldValue("preco", isNumber ? Number(event.target.value) : event.target.value );
    };*/

    const handlePriceChange = (e, itemID, isNumber) => {
        const newPrice = isNumber ? Number(e.target.value) : e.target.value;
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("newPrice>>",newPrice)
        setCurrentPrice(newPrice);
        setItens(prevItens =>
            prevItens.map(item =>
                item._id === itemID ? { ...item, price: newPrice } : item
            )
        );
    };

    const [_idCategoriaToEdit] = useState("")
    const [id_categoria] = useState("")
    const [_titleToEdit] = useState("")
    const [_disponibilidadeToEdit, setDisponibilidadeToEdit] = useState("")
    const [_diaHorarioDispToEdit, setDiaHorarioDispToEdit] = useState([])


    const handleRefresh = () => {
        setLoading(true);
        setRefresh(true);
    }



    const handleEditClick = (itemObjId) => {
        navigate(`/edit-item`, { state: { itemObjId } });
    };



    const [, setCopied] = useState(false);
    const [isFocused, setIsFocused] = useState(false);


    const handleCopyClick = (productID) => {
        const hostname = window.location.hostname === "localhost" ? "http://localhost:3000" : `https://${window.location.hostname}`;
        const link = `${hostname}/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/detalhes/${productID}`
        navigator.clipboard.writeText(link).then(() => {
            setCopied(true);
            toast(t('copyLinkSuccess'), { autoClose: 2500, type: "success" });
            setTimeout(() => setCopied(false), 2000); // Reset the copied state after 2 seconds
        }).catch((err) => {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Failed to copy: ', err);
        });
    };

    
    var arrayCategorias = categorias.sort( (a, b) => {
        return a.order - b.order;
    });

    var arrayItens = itens.sort((a, b) => {
        return a.order - b.order;
    });

    const handleScrollOnClick = (mongodbId) => {
        const element = document.getElementById(mongodbId);
        if (element) {
          setSelectedCategoria(mongodbId)
          element.scrollIntoView({ behavior: "smooth" });
        } else {
            toast(t('listItemPage.categoryNoItems'), {
                autoClose: 2500,
                type: "warning",
            });
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.error(`Element with id ${mongodbId} not found`);
        }
    };
    
    if (filter){
        const sanitizedFilter = filter.replace(/[^\d\w]+/g,'.*');
        const exp = new RegExp(sanitizedFilter, 'i');
        list = categorias.filter( item => exp.test( item.title ) )
    }

    const handleFilter = e => {
        setFilter(e.target.value);
        setResult(!result);
    }

    const handleCadastro = () => {
        navigate("/cadastro-item");
    }


    const [draggedItem, setDraggedItem] = useState(null);
    const handleDragStart = (draggableId) => {
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("draggedItem>",draggableId)
        setDraggedItem(draggableId);
    };
    const handleDragEnd = () => {
        setDraggedItem(null);
        /*//process.env.REACT_APP_ISDEVELOP === 'true' && console.log("destination",destination)
        if (!destination) { // || destination.droppableId === source.droppableId){
          //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("caiu aqui.")
          return;
        }
        const draggedItem = itens.filter((item) => item._id === source.draggableId)[0];
      
        const newItens = [...itens]
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("newItens>",newItens)
        newItens.splice(source.index, 1);
        newItens.splice(destination.index, 0, draggedItem)
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("newItens2>",newItens)
        //setItens(newItens);*/
    };

    const moveRow = async (source, destination) => {
        
        const filteredItens = itens.filter(item => item.category_item_id === source.droppableId);
        ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("source>",source)
        ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("destination>",destination)
        ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("filteredItens>",filteredItens)

        const dragItem = filteredItens[source.index];

        ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("dragItem>",dragItem)
      
        // Mover o item do dragIndex para o hoverIndex
        const newItens = [...filteredItens];        
        newItens.splice(source.index, 1);
        newItens.splice(destination.index, 0, dragItem);
        // Atualizar o estado com o novo array de itens
        const itensAtualizados = newItens.map((item, index) => {
            return { ...item, order: index+1 };
        });
        


        const itensAtualizadosMap = itensAtualizados.reduce((acc, item) => {
            acc[item._id] = item;
            return acc;
        }, {});

        const newItensArray = itens.map(item => {
            const itemAtualizado = itensAtualizadosMap[item._id];
            return itemAtualizado || item;
        });

        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(newItensArray);

        const promises = newItensArray.map( (itensToApi) => {
            return updateItensOrder(userID, itensToApi._id, itensToApi.id_item, itensToApi.id_empresa, itensToApi.order).then(response => {
                return response;
            }).catch(err => {
                return err;
            })
        });
        Promise.all(promises).then(results => {
            toast(t('order.updateSuccess'),{ autoClose: 2500 , type: "success"});
        }).catch(err => {
            toast(t('order.updateError'),{ autoClose: 2500 , type: "error"});
        });        

        setItens(newItensArray);
    };

    return(

        <>
        <PermissionGate permissions={['default']}>

            {/*<LeftMenu setSidebar={setSidebar} sidebar={sidebar} />*/}

            <ConfirmDialog
                title={t('actions.confirmDeleteItem')}
                open={confirmOpen}
                setOpen={setConfirmOpen}
                onConfirm={deleteReg}
            >
                <div>
                    {t('actions.confirmDeleteItemMsg')}
                </div>
            </ConfirmDialog>

            <ModalEditCategoria showEditCategoria={showEditCategoria}
            setEditCategoria={setEditCategoria}
            setRefresh={setRefresh}
            _idCategoriaToEdit={_idCategoriaToEdit}
            id_categoria={id_categoria}
            _titleToEdit={_titleToEdit}
            _disponibilidadeToEdit={_disponibilidadeToEdit}
            setDisponibilidadeToEdit={setDisponibilidadeToEdit}
            _diaHorarioDispToEdit={_diaHorarioDispToEdit}
            setDiaHorarioDispToEdit={setDiaHorarioDispToEdit}
            />

            <Teste sidebar={sidebar}>
            
                {loading && <Loading type={"spinningBubbles"} style={{marginLeft:'14%'}} className="calculandoDistanciaModalEntrega"/>}
                <div className="w-100 p-4">
                    <div className="list-header-categories">
                        <div className="title">
                            <h1>{t('listItemPage.title')}</h1>
                        </div>
                    </div>


                    <div className="flex-column flex-md-row" style={{display:"flex", justifyContent:"space-between"/*, height:"80px"*/}}>
                        <div className="input-box-list" style={{ maxWidth: "400px", width: "100%"}}>                
                            <input className="input-field" placeholder={t('searchPlaceholder')} onChange={handleFilter}/>
                            <i className="icon"><FiIcons.FiSearch/></i>
                        </div>

                        <div className="div-buttons flex-column flex-md-row mb-2">
                            <div className="continue-button">                           
                                <button onClick={handleCadastro}>
                                    <AiIcons.AiOutlinePlusCircle style={{marginRight: "5px",fontSize: "22px",marginBottom: "2px"}}/><a>{t('addButton')}</a>
                                </button>                            
                            </div>

                            <div className="refresh-button" style={{ textAlign: "start" }}>                                                       
                                <button className="refresh-button" onClick={handleRefresh}>
                                    <SlIcons.SlRefresh style={{color:"#4281FF",marginRight: "5px",fontSize: "18px",marginBottom: "2px"}}/><a>{t('refreshButton')}</a>
                                </button>
                            </div>
                        </div>

                    </div>

                    
                    <div className="divPaiCategorias">

                        <div className="grid-cardapio" style={{width:'96%'}}>
                            
                            
                            <div className="center-cardapio horizontal">

                                
                                <div className="categoria-cardapio horizontal">
                                {arrayCategorias &&
                                    arrayCategorias
                                    /*.filter((cats) =>
                                        itens.some((item) => item.category_item_id === cats._id)
                                    )*/
                                    .map((c, i) => (
                                        <div
                                        key={Math.random()}
                                        className="categoria-item"
                                        onClick={() => handleScrollOnClick(c._id)}
                                        style={{
                                            background:
                                            c._id === selectedCategoria ? "rgb(49, 140, 213)" : "",
                                            color: c._id === selectedCategoria ? "white" : "",
                                        }}
                                        >
                                        <span>{c.title}</span>
                                        </div>
                                    ))}
                                </div>
                                
                                <div className="overflow-itensHorizontal">
                                    {arrayCategorias &&
                                        arrayCategorias.map((category, i) => (
                                            <div key={i} className="same-category">
                                                <div key={category._id} id={category._id} className="categoria-item-title">
                                                <span key={Math.random()} className="titulo-item">
                                                    {category.title}
                                                </span>
                                                </div>
                                                <DragDropContext onDragStart={(event) => handleDragStart(event.draggableId)} onDragEnd={({ source, destination }) => {
                                                handleDragEnd();
                                                if (destination) {
                                                    moveRow(source, destination);
                                                }
                                                }}>
                                                <Droppable droppableId={category._id} direction="vertical">
                                                    {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        <div className="itens-categoriaHorizontal">
                                                            {arrayItens && arrayItens
                                                                .filter((item) => item.category_item_id === category._id)
                                                                .map((item, index) => (
                                                                <Draggable key={item._id} draggableId={item._id} index={index}>
                                                                    {(provided) => (
                                                                    <div
                                                                    {...provided.draggableProps}                                                                    
                                                                    ref={provided.innerRef}
                                                                    className={`${"resultItem"} ${
                                                                    index % 2 === 0 ? "even" : "odd"
                                                                    }`}
                                                                    style={{
                                                                        ...provided.draggableProps.style,
                                                                        backgroundColor: draggedItem===item._id ? 'white' : 'white',
                                                                        boxShadow: draggedItem===item._id ? '1px 1px 6px #a4a4a4' : 'none',
                                                                    }} // Adicione essa linha
                                                                    >
                                                                        <div className="itensList">
                                                                            <div className="divItemImgList">
                                                                                <SafeImage
                                                                                    width={100}
                                                                                    height={100}
                                                                                    src={item.image}
                                                                                    alt={item.title}
                                                                                    fallback={
                                                                                        <div className="iconWhenImgNull">
                                                                                            <MdFastfood style={{ fontSize: 75 }} />
                                                                                        </div>
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            <div className="divItemNameList flex-column flex-lg-row">
                                                                                <div className="titlePlusDragIcon" {...provided.dragHandleProps}>
                                                                                    <MdDragIndicator style={{fontSize:30, color:"darkgray"}}/>
                                                                                    <span>{item.title}</span>
                                                                                </div>
                                                                                <div className="itemsOptJustifyEnd">
                                                                                    <div className="divItemPrice">
                                                                                        {visibleInput === item._id ?
                                                                                            <div ref={inputRef}>                                                                                                                                                                                   
                                                                                                <InputMoney
                                                                                                    onChange={(event) => handlePriceChange(event, item._id, true)}
                                                                                                    value={item.price}
                                                                                                    onBlur={() => handleBlurOrEnter(item._id, item.id_item, item.price)}
                                                                                                    onKeyDown={(e) => {
                                                                                                        if (e.key === 'Enter') {
                                                                                                            handleBlurOrEnter(item._id, item.id_item, item.price);
                                                                                                        }
                                                                                                    }}
                                                                                                    autoFocus                                                                                                    
                                                                                                    margin="0px 0px 16px 0px"
                                                                                                    style={{
                                                                                                    outline: isFocused ? '2px solid #4070f4' : 'none',
                                                                                                    borderRadius:6,
                                                                                                    margin: '0.6rem 0 0.2rem 0',
                                                                                                    }}
                                                                                                    className="inputPersonalizedItem"
                                                                                                    placeholder={t('pricePlaceholder')}
                                                                                                /> 
                                                                                            </div>
                                                                                        :                                                                                        
                                                                                        <>
                                                                                            <span>{formatPriceWithSymbol(item.price)}</span>
                                                                                            <div className={"icon-btn edit-print"} onClick={()=>toggleInput(item._id, item.price)}>
                                                                                                <div>
                                                                                                    <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width={16}
                                                                                                    height={16}
                                                                                                    viewBox="0 0 24 24"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    strokeWidth={2}
                                                                                                    strokeLinecap="round"
                                                                                                    strokeLinejoin="round"
                                                                                                    className="feather feather-edit-2"
                                                                                                    >
                                                                                                    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                                                                                                    </svg>
                                                                                                </div>                                                                                                
                                                                                            </div>
                                                                                        </>
                                                                                        }
                                                                                    </div>
                                                                                    <div className="divEsgotarItem">
                                                                                        <span>{t('listItemPage.outOfStock')}</span>
                                                                                        <div className="wrapper">
                                                                                            <div className="switch_box box_1">                                                                                                
                                                                                                <input type="checkbox" className="switch_1" 
                                                                                                checked={item.out} onChange={()=> handleCheckboxChange(item._id, item.id_item, item.out)}/>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="divLinkAcoes">
                                                                                        <div>
                                                                                            <span className="actionsItem" onClick={() => handleCopyClick(item._id)}><IoLink fontSize={15}/> {t('copyLink')}</span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <span onClick={() => toggleOptions(item._id)}
                                                                                            style={{
                                                                                            }}                                                                                            
                                                                                            className="actionsItem"
                                                                                            >
                                                                                                {t('itemActions')} <MdKeyboardArrowDown />
                                                                                            </span>
                                                                                            {visibleDropdown === item._id && (
                                                                                                <div className="optionsDropdown" ref={dropdownRef}>
                                                                                                    <div 
                                                                                                        className="optionItem" 
                                                                                                        onClick={() => handleEditClick(item._id)}
                                                                                                    >
                                                                                                        <FaRegEdit /> {t('actions.edit')}
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="optionItem"
                                                                                                        onClick={() => handleDeleteItem(item._id)}
                                                                                                    >
                                                                                                        <FaRegTrashAlt /> {t('actions.delete')}
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="optionItem"
                                                                                                        onClick={() => handleEditAdditionalClick(item._id)}
                                                                                                    >
                                                                                                        <FaRegEdit /> {t('editAdditionals')}
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <input
                                                                                //onChange={process.env.REACT_APP_ISDEVELOP === 'true' && console.log()}
                                                                                value={num[index]}
                                                                                type="number"
                                                                                style={{
                                                                                display: isNaN(num[index]) ? "none" : "",
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        {provided.placeholder}
                                                                    </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {/* Esta parte é para verificar se há itens na categoria */}
                                                            {arrayItens.filter((item) => item.category_item_id === category._id).length === 0 && (
                                                                <div className="nenhumItem">{t('noItems')}</div>
                                                            )}
                                                        </div>
                                                    {provided.placeholder}
                                                    </div>
                                                    )}
                                                </Droppable>
                                                </DragDropContext>
                                            </div>
                                        ))}
                                    
                                </div>



                            </div>
                            
                            
                        </div>

                    </div>
                            
                </div>            
            </Teste>

        </PermissionGate>       
        </>
        

    );
};


export default ListItem;